import { ConfiguredMiddleware } from 'wretch'

import { auth$ } from '~in-app/legend-state'

export type AutoAuthorization = () => ConfiguredMiddleware

export const autoAuthorization: AutoAuthorization = () => {
  return next => (url, { headers, ...opts }) => {
    const nextHeaders = new Headers(headers)

    const authJwt = auth$.jwt.get()

    if (authJwt) {
      nextHeaders.set('Authorization', `Bearer ${authJwt}`)
    }

    return next(url, { ...opts, headers: nextHeaders })
  }
}
